module.exports = __webpack_public_path__ + "img/poker-c04.6d15258c.svg";